import React from 'react'
import { Link } from 'react-router-dom' //NO QUITAR, COMENTADO TEMPORALMENTE
import plus from '../../assets/images/icons/plus.svg' //NO QUITAR, COMENTADO TEMPORALMENTE

const ServiceItem = ({ icon, title, copy, link }) => {
    return (
        <div className="service-item">
            <div className="icon">
                <img src={icon} alt="" />
            </div>
            <h3>{title}</h3>
            <p>{copy}</p>

            <div className="link-btn">
                <img src={plus} alt="Ir a ...." />
            </div>
            {/* NO QUITAR, COMENTADO TEMPORALMENTE */}
            {/* <Link to={link} className="link-btn">
                <img src={plus} alt="Ir a ...." />
            </Link> */}
        </div>
    )
}

export default ServiceItem
